
import Component from './component';
import createComponentFactory from '../createComponent';
import Ticker from '../utils/Ticker';
import prefix from 'prefix';
import resizeObserver from '../utils/ResizeObserver';

class PrimaryBanner extends Component {

  constructor(element, context, options) {
    super(element, context, options);

    this.scrollable = element.querySelector('.js-primaryBanner__scrollable');

    this._scrollWidth = element.scrollWidth;
    this._lastMouseX = 0;
    this._slipX = 0;
    this._margin = 150;

    this._handleMouseMove = this._handleMouseMove.bind(this);
    this._handleMouseOver = this._handleMouseOver.bind(this);
    this._handleMouseOut = this._handleMouseOut.bind(this);
    this._update = this._update.bind(this);
  }

  _bindEvents() {
    this.element.addEventListener('mouseenter', this._handleMouseOver);
    this.element.addEventListener('mouseleave', this._handleMouseOut);
    this.element.addEventListener('mousemove', this._handleMouseMove);
    Ticker.sharedTicker.addListener(this._update);

    resizeObserver.addListener(this._handleResize);
  }

  _unbindEvents() {
    this.element.removeEventListener('mouseenter', this._handleMouseOver);
    this.element.removeEventListener('mouseleave', this._handleMouseOut);
    this.element.removeEventListener('mousemove', this._handleMouseMove);
    Ticker.sharedTicker.removeListener(this._update);

    resizeObserver.removeListener(this._handleResize);
  }

  _handleResize() {
    this._scrollWidth = this.element.scrollWidth;
  }

  _handleMouseOver(evt) {
  }

  _handleMouseOut(evt) {
  }

  _handleMouseMove(evt) {
    this._lastMouseX = evt.clientX;
  }

  _update() {
    const ww = window.innerWidth;
    const runover = this._scrollWidth - ww;

    let mouseX = this._lastMouseX;

    if(mouseX < this._margin) {
      mouseX = 0;
    } else {
      mouseX -= this._margin;
    }

    if(mouseX > ww - this._margin) {
      mouseX = ww - this._margin;
    }

    if(runover <= 0) {
      return;
    }

    const ratio = Math.min(1, Math.max(mouseX / (ww - this._margin * 2), 0));
    let slip = (runover * ratio - this._slipX) * 0.1 + this._slipX;

    if(Math.abs(runover * ratio - slip) < 0.01) {
      slip = runover * ratio;
    }

    this.scrollable.style[prefix('transform')] = `translate3d(${-slip}px, 0, 0)`;

    this._slipX = slip;
  }

  didRegisterComponent() {

    this._containerRect = this.element.getBoundingClientRect();
    this._bindEvents();
  }

  didUnregisterComponent() {
    this.scrollable.style[prefix('transform')] = '';
    this._unbindEvents();
  }
}

export default createComponentFactory(PrimaryBanner);



// WEBPACK FOOTER //
// ./src/js/app/component/primaryBanner.js